(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 99133:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(90114);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2722);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83242);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17566);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_components__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36457);







var NotFoundPage = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function() {
    var push = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().push;
    var t = (0,_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useTranslator */ .I4)().t;
    var onClick = function() {
        push("/");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_5__.HeadTag, {
                seo: {
                    title: "Mammafiore | ".concat(t("commons.page_error.title")),
                    description: t("commons.page_error.description")
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_5__.HeaderMarquee, {
                data: t("commons.page_not_found.404")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_error__WEBPACK_IMPORTED_MODULE_6__.ErrorMain, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_error__WEBPACK_IMPORTED_MODULE_6__.ErrorSection, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: t("commons.page_not_found.title")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("commons.page_not_found.description")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_5__.Button, {
                            onClick: onClick,
                            children: t("commons.page_not_found.goback_homepage")
                        })
                    ]
                })
            })
        ]
    });
});
NotFoundPage.Layout = _components__WEBPACK_IMPORTED_MODULE_4__.Layout;
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (NotFoundPage);


/***/ }),

/***/ 36457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ErrorMain": function() { return /* binding */ ErrorMain; },
/* harmony export */   "ErrorSection": function() { return /* binding */ ErrorSection; },
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2722);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19453);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83242);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17566);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_components__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73267);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _dy_commons_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76079);
/* harmony import */ var _dy_commons_utils__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_utils__WEBPACK_IMPORTED_MODULE_8__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-grow: 2;\n  overflow-x: hidden;\n  padding: 0;\n  position: relative;\n\n  ",
        " {\n    overflow-x: inherit;\n  }\n\n  ",
        " {\n    margin: 0 auto;\n    max-width: 1650px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  grid-column: 1 / span 6;\n  padding: ",
        " ",
        ";\n  align-items: center;\n  margin-bottom:",
        " ;\n\n  ",
        " {\n    padding: ",
        " ",
        ";\n    margin-bottom:",
        ";\n  }\n\n  ",
        " {\n    grid-column: 5 / span 4;\n    padding: ",
        " 0;\n    margin-bottom:",
        " ;\n  }\n\n  ",
        " {\n    padding: 60px 0;\n    margin-bottom: 60px;\n  }\n\n  button {\n    color: ",
        ";\n    margin-top: ",
        ";\n\n    ",
        " {\n      margin-top:",
        ";\n    }\n\n    ",
        " {\n      margin-top:",
        ";\n    }\n\n    ",
        " {\n      margin-top: 30px;\n    }\n  }\n\n  h2, p {\n    font-family: ",
        ";\n    padding: 15px;\n    text-align: center;\n  }\n\n  h2 {\n    ",
        "\n    color: ",
        ";\n    font-weight: 700 !important;\n  }\n\n  p {\n    ",
        "\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var ErrorPage = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(param) {
    var errorCode = param.errorCode, statusCode = param.statusCode;
    console.log("❌ errorCode:", errorCode);
    console.log("❌ statusCode:", statusCode);
    var push = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().push;
    var t = (0,_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useTranslator */ .I4)().t;
    var setCustomer = (0,_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useCustomer */ .ON)().setCustomer;
    var onClick = function() {
        push("/?logout=true");
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        _dy_commons_utils__WEBPACK_IMPORTED_MODULE_8__.cookie.removeCookie("BC_CUSTOMER_ID");
        _dy_commons_utils__WEBPACK_IMPORTED_MODULE_8__.cookie.removeCookie("DY_CUSTOMER_TOKEN");
        setCustomer(null);
    }, [
        setCustomer
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_6__.HeadTag, {
                seo: {
                    title: "Mammafiore | ".concat(t("commons.page_error.title")),
                    description: t("commons.page_error.description")
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_6__.HeaderMarquee, {
                data: t("commons.page_error.500")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ErrorMain, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ErrorSection, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                            children: t("commons.page_error.title")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                            children: t("commons.page_error.description")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_6__.Button, {
                            onClick: onClick,
                            children: t("commons.page_error.goback_homepage")
                        })
                    ]
                })
            })
        ]
    });
});
ErrorPage.Layout = _components__WEBPACK_IMPORTED_MODULE_5__.Layout;
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (ErrorPage);
var ErrorMain = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].main.withConfig({
    displayName: "_error__ErrorMain",
    componentId: "sc-25f428e-0"
})(_templateObject(), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("tablet"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("desktop-wide"));
var ErrorSection = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].section.withConfig({
    displayName: "_error__ErrorSection",
    componentId: "sc-25f428e-1"
})(_templateObject1(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(50, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(20, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(50, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(50, "nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(20, "nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(50, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(60, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(60, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(60, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(60, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(30, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.getP26_1)(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.getP18_1)(), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(99133); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);